import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { RegisterModel } from 'src/app/models/register.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { faX } from '@fortawesome/free-solid-svg-icons'; // O far para regular
import { PostRegistrationWelcomeComponent } from 'src/app/components/modals/post-registration-welcome/post-registration-welcome.component';
import { VerifyAccountComponent } from '../verify-account/verify-account.component';
import { DOCUMENT } from '@angular/common';
import { InfoMessageService } from 'src/app/services/info-message.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {
  @Input() title = '';
  @Input() msg = '';
  @Input() btn_msg_yes = '';
  @Input() btn_msg_no = '';
  @Input() callback_yes = () => {};
  @Input() callback_no = () => {};
  registerFormGroup: RxFormGroup;
  isLogin = false;
  faClose = faX;
  typePassword: boolean = true;
  modalWelcome?: NgbModalRef;
  ngbModal: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    // size: 'lg',
    keyboard: false,
    centered: true,
  };
  private loginSubscription: Subscription;
  private registerSubscription: Subscription;
  constructor(
    public activeModal: NgbActiveModal,
    private fb: RxFormBuilder,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private messageService: InfoMessageService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initForm();
  }
  async initForm(): Promise<void> {
    return new Promise((resolve) => {
      const registerModel = new RegisterModel();
      this.registerFormGroup = this.fb.formGroup(registerModel) as RxFormGroup;
      if (this.authService.tempUserRegistrationData && 
        Object.keys(this.authService.tempUserRegistrationData).length > 0) {
        this.registerFormGroup.patchValue({
          email: this.authService.tempUserRegistrationData.email
          || this.authService.tempUserRegistrationData.phone,
          password: this.authService.tempUserRegistrationData.password,
          passwordConfirm: this.authService.tempUserRegistrationData.password,
          name: this.authService.tempUserRegistrationData.name,
          lastname: this.authService.tempUserRegistrationData.lastname
        });
        this.authService.tempUserRegistrationData = {};
      }
      resolve();
    });
  }
  loginUser(email: any, password: any) {
    console.log('loginUser called in register component with:', { email, password });
    this.loginSubscription = this.authService.login(email, password).subscribe({
      next: async (responseLogin) => {
        console.log('Login response in register component:', responseLogin);
        await this.authService.setData(responseLogin);
        console.log('setData completed in register component');
        this.isLogin = false;
        this.onYes(); 
       
      },
      error: (error) => {
        console.error('Login error in register component:', error);
        this.isLogin = false; // Hide loader
      },
    });
  }
  register() {
    console.log('Iniciando registro...')
    if (this.registerFormGroup.valid) {
      this.isLogin = true; // Show loader or spinner
      const { email, password, name, lastname } = this.registerFormGroup.value;
      
      this.authService.tempUserRegistrationData = {
          ...(this.isNumber(email) ? { phone: email } : { email: email }),
          password,
          name,
          lastname
      }
      this.registerSubscription = this.authService.register(email, password, name, lastname, this.document.location.origin).subscribe({
        next: async (response) => {
          console.log('response', response);
          this.activeModal.close('register');
          this.modalWelcome = this.modalService.open(VerifyAccountComponent, this.ngbModal);
          this.modalWelcome.componentInstance.title = "Crear cuenta";
          this.modalWelcome.componentInstance.msg = "Te hemos enviado un código al " + (this.isNumber(email) ? "número diligenciado" : " correo diligenciado") + ", escríbelo aquí validar el registro.";
          this.modalWelcome.componentInstance.method = 'register';
          this.modalWelcome.result.then(() => {
          }, () => {
            this.activeModal.close('register');
            this.callback_yes();
          });
          // this.isLogin = false;
          // this.loginUser(email, password);
          // this.welcome();
          // this.authService.notifyLoginSuccess();
        },
        error: (error) => {
          this.isLogin = false; // Hide loader or spinner
          
          this.authService.tempUserRegistrationData = {}
        },
      });
    } else {
      // Mark all controls as touched to display validation errors
      this.registerFormGroup.markAllAsTouched();
    }
  }

  showVerifyAccountModal(){
    this.activeModal.close('register');
    this.modalWelcome = this.modalService.open(VerifyAccountComponent, this.ngbModal);
    this.modalWelcome.result.then(() => {
    }, () => {
      this.activeModal.close('register');
      this.callback_yes();
      // Notificar al header que el login fue exitoso
      this.authService.notifyLoginSuccess();
    });
  }

  welcome() {
    this.activeModal.close('register');
    /* this.modalWelcome = this.modalService.open(
      PostRegistrationWelcomeComponent,
      this.ngbModal
    ); */
    this.modalWelcome.result.then(
      () => {},
      () => {
        this.activeModal.close('login');
        this.callback_yes();
      }
    );
  }
  showPassword() {
    this.typePassword = !this.typePassword;
  }
  onYes() {
    this.activeModal.close('Close click');
    this.callback_yes();
  }
  openWelcomeModal() {
    this.modalWelcome = this.modalService.open(
      PostRegistrationWelcomeComponent,
      this.ngbModal
    );
    this.modalWelcome.result.then(
      () => {
        // Handle modal close success
      },
      () => {
        // Handle modal dismiss
        this.activeModal.close('login');
        this.callback_yes();
      }
    );
  }

  onNo() {
    this.activeModal.close('Close click');
    this.authService.tempUserRegistrationData = {};
    this.callback_no();
  }

  limitDigitsForPhone(eventData: any){
    this.registerFormGroup.get('phone')?.setValue((
      <HTMLInputElement> eventData.target).value.substring(0,10)
    );
  }

  onEmailInput(eventData: any){
    const inputElement = eventData.target as HTMLInputElement;
    const value = inputElement.value;

    const isNumber = this.isNumber(value);

    if(isNumber && value.length > 10){
      this.registerFormGroup.get('email')?.setValue(
        inputElement.value.substring(0,10)
      );
    }
  }

  isNumber(value: string){
    return /^-?\d*\.?\d+$/.test(value);
  }

  ngOnDestroy(){
    this.messageService.hideActiveMessage();
    if(this.loginSubscription){
      this.loginSubscription.unsubscribe();
    }
    if(this.registerSubscription){
      this.registerSubscription.unsubscribe();
    }
  }
}
